import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const BookingsLastNameWUT = props => {
  const fieldType = FIELD_TYPES.BOOKINGS_LAST_NAME;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=bookings-last-name-wut.js.map